import React from 'react';
import {
  Grid,
  Box,
  Tabs,
  Tab,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import { PersonAddAlt } from '@mui/icons-material';
import { useEffect } from 'react';

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};
export default function AudienceTags({
  selectedTab,
  setSelectedTab,
  audiences,
  setAudiences,
}) {
  const [leftAudience, setLeftAudience] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    let a = [];
    if (audiences.indexOf(1) === -1) {
      a.push(1);
    }
    if (audiences.indexOf(2) === -1) {
      a.push(2);
    }
    if (audiences.indexOf(4) === -1) {
      a.push(4);
    }
    setLeftAudience(a);
  }, [audiences, selectedTab]);

  return (
    <Tabs
      className='audience-tabs'
      value={selectedTab}
      onChange={(e, newValue) => {
        setSelectedTab(newValue);
      }}
      TabIndicatorProps={{
        style: {
          display: 'none',
        },
      }}
    >
      {audiences?.map((audience, index) => (
        <Tab
          disableRipple={true}
          label={
            <Box
              sx={{
                backgroundColor:
                  selectedTab === audience ? '#007A7A' : '#e2e2e2',
                borderRadius: '4px',
                color: selectedTab === audience ? '#ffffff' : '#4F4F4F',
                padding: '12px 15px',
              }}
            >
              {audience === 1
                ? 'Staff'
                : audience === 2
                ? 'Parent'
                : audience === 4
                ? 'Pupil'
                : 'All'}
              {audiences.length > 1 && selectedTab === audience && (
                <div
                  className='remove-audience'
                  onClick={(e) => {
                    e.stopPropagation();
                    alert('remove audience');
                    if (audiences.length > 1) {
                      let a = audiences;
                      a = a.filter((aud) => aud !== audience);
                      setSelectedTab(a[a.length - 1]);
                      setAudiences(a);
                    }
                  }}
                >
                  <svg
                    width='9'
                    height='9'
                    viewBox='0 0 9 9'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M8.331 6.9175L5.58 4.166L8.33 1.415L6.9165 0L4.165 2.751L1.414 0L0 1.415L2.75 4.166L0 6.917L1.415 8.331L4.165 5.58L6.915 8.331L8.331 6.9175Z'
                      fill='white'
                    />
                  </svg>
                </div>
              )}
            </Box>
          }
          value={audience}
          {...a11yProps(audience)}
          key={index}
        />
      ))}
      {leftAudience.length > 0 && (
        <IconButton
          id='demo-positioned-button'
          aria-controls={open ? 'demo-positioned-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          disableRipple={true}
        >
          <PersonAddAlt></PersonAddAlt>
        </IconButton>
      )}
      <Menu
        id='demo-positioned-menu'
        aria-labelledby='demo-positioned-button'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {leftAudience.map((audience, index) => (
          <MenuItem
            value={audience}
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              let a = audiences;
              a.push(audience);
              setAudiences(a);
              setLeftAudience(leftAudience.filter((t) => t !== audience));
              handleClose();
            }}
          >
            {audience === 1 ? 'Staff' : audience === 2 ? 'Parent' : 'Pupil'}
          </MenuItem>
        ))}
      </Menu>
    </Tabs>
  );
}
